import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

export const border = {
  '&:after': {
    position: 'absolute',
    display: 'block',
    content: '""',
    height: 3,
    width: 'calc(100% - 32px)',
    backgroundColor: colorsPalette.violet,
    opacity: 0.3,
    left: 16,
    bottom: 0,
  },
};

const useStyles = (hasChildCategories) =>
  makeStyles((theme: Theme) =>
    createStyles({
      errorWrapper: {
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      withImageWrapper: {
        marginBottom: hasChildCategories ? 0 : MIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          paddingBottom: 0,
          marginBottom: LARGE_MARGIN,
        },
      },
      withImageContentWrapper: {
        paddingBottom: '0 !important',
      },
      withImgContainer: {
        paddingTop: MIDDLE_MARGIN,
        paddingBottom: hasChildCategories ? SMALL_MARGIN : MIDDLE_MARGIN,
        ...(!hasChildCategories && border),
        [theme.breakpoints.up('md')]: {
          paddingTop: LARGE_MARGIN,
          paddingBottom: MIDDLE_MARGIN,
          position: 'relative',
          ...border,
        },
      },
      withoutImageContainer: {
        position: 'relative',
        marginBottom: MIDDLE_MARGIN,
        paddingBottom: MIDDLE_MARGIN,
        ...border,
        [theme.breakpoints.up('md')]: {
          marginBottom: LARGE_MARGIN,
        },
      },
      childCategoriesContainer: {
        position: 'relative',
        marginBottom: MIDDLE_MARGIN,
        ...border,
        [theme.breakpoints.up('md')]: {
          display: 'none',
        },
      },
      headerCategoriesWrapper: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
          display: 'flex',
        },
      },
      categoriesWrapper: {
        [theme.breakpoints.up('md')]: {
          display: 'none',
        },
      },
    }),
  );

export default useStyles;
